import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-atendimento-view',
  templateUrl: 'atendimento-view.html',
})
export class AtendimentoViewPage {

  atendimento:any = {};

  constructor(public navCtrl: NavController, private navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.atendimento = this.navParams.get('atendimento');
  }
}



// WEBPACK FOOTER //
// ./src/pages/atendimento/atendimento-view/atendimento-view.ts